<script>
import mixins from '../mixins'
import groupBy from 'lodash/groupBy'
import maxBy from 'lodash/maxBy'
import { getGoodsGroup } from '@utils/goods-group'

export default {
  name: 'DrumsWithTheRemainder',
  mixins: [mixins],
  data() {
    return {
      modelName: 'DrumsWithTheRemainder',
      columns: [
        { text: 'workshop', value: 'organisation', sortable: true },
        { text: 'drum_plug_no', value: 'serial', sortable: true },
        { text: 'oil_type', value: 'oil', sortable: true },
        { text: 'drum_volume', value: 'drum_volume', sortable: true },
        { text: 'current_volume_in', value: 'current_amount', sortable: true },
        { text: 'current_temperature', value: 'temperature', sortable: true },
      ],
    }
  },
  computed: {
    goods() {
      return this.$store.getters['data/getDictionary']('goods')
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.loading = true
      const remains = await this.getRemains()
      const result = []
      const remainsBySerial = groupBy(remains, 'serial')
      for (const serial in remainsBySerial) {
        const item = remainsBySerial[serial]
        const lastRecord = maxBy(item, 'time')
        const { organisation, amount, temperature, goods } = lastRecord
        if (amount > 5000) continue
        const oil = await this.getOil(goods)
        let goodsGroup = getGoodsGroup(this.goods, goods)
        result.push({
          organisation,
          serial,
          oil,
          amount,
          goodsGroup,
          temperature,
        })
      }
      this.data = [...result]
      this.loading = false
      this.getPaginator()
    },
  },
}
</script>

<template>
  <div>
    <v-data-table
      :headers="columns"
      :items="filteredData"
      :pagination="pagination"
      :loading="loading"
      :rows-per-page-items="rowsPerPage"
      :class="$style.sdTable"
      @update:pagination="onPaginationChange"
    >
      <template 
        slot="headerCell" 
        slot-scope="props">
        {{ $t(`label__${props.header.text}`) }}
      </template>
      <template
        slot="items"
        slot-scope="props"
      >
        <tr>
          <td>{{ getValue('organization', props.item.organisation) }}</td>
          <td> <router-link
            v-if="userAllowedToNavigate"
            :to="{ name: 'searchPlug', params: { serial: props.item.serial, goodsGroup: props.item.goodsGroup }} "> {{ props.item.serial }}
          </router-link>
            <span v-else>{{ props.item.serial }}</span>
          </td>
          <td>{{ getValue('goods', props.item.oil) }}</td>
          <td>{{ `${(props.item.drum_volume / unitsMeasurement.volumeMultiplier).toFixed(1)}` }}</td>
          <td>{{ `${(props.item.amount / unitsMeasurement.volumeMultiplier).toFixed(1)}` }}</td>
          <td>{{ convertTemperature(props.item.temperature) }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.sdTable {
  border: 1px solid #dfdfdf;

  th {
    outline: none;
  }
}
</style>
